export const SYMBOL_NAMES = {
  REGULAR: "bxCnReg",
  DISABLED: "bxCnDis",
  PROHIBITED: "bxCnPrh",
  EMPHASIZED: "bxEmph",
};
